import { render, staticRenderFns } from "./AddUpdateNote.vue?vue&type=template&id=08cabf50&scoped=true&"
import script from "./AddUpdateNote.vue?vue&type=script&lang=js&"
export * from "./AddUpdateNote.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateNote.vue?vue&type=style&index=0&id=08cabf50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cabf50",
  null
  
)

export default component.exports